import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/store/auth'; // Adapter le chemin si nécessaire
import HomeView from '../views/HomeView.vue'
import ContactView from '../views/ContactView.vue'
import DashboardView from '../views/DashboardView.vue'
import ReservationView from '../views/ReservationView.vue'
import LogementsView from '../views/LogementsView.vue'
import AboutView from '../views/AboutView.vue'
import DetailsLogement from '../views/DetailsLogement.vue'

import ApartmentDetails from '../views/ApartmentDetails.vue';
//import AdminDashboard from '../views/AdminDashboard.vue';
import Home from "../views/Home.vue"
import AdminApartmentList from '@/views/admin/AdminApartmentList.vue'
import AdminAddApartment from '@/views/admin/AdminAddApartment.vue'
import AdminEditApartment from '@/views/admin/AdminEditApartment.vue'
import AdminEmployee from '@/views/admin/AdminEmployee.vue'
import AdminSiteList from '@/views/admin/AdminSite.vue'
import ClientMultiStepReservation from '@/views/ClientMultiStepReservation.vue'
import AdminReview from '@/views/admin/AdminReview.vue';


// Importez vos vues/composants
// Exemple:
// import HomeView from '../views/HomeView.vue';
// import LoginView from '../views/LoginView.vue';
// import RegisterView from '../views/RegisterView.vue';
// import ProfileView from '../views/ProfileView.vue';
// import ForgotPasswordView from '../views/ForgotPasswordView.vue';
// import ResetPasswordView from '../views/ResetPasswordView.vue';
// import VerifyEmailView from '../views/VerifyEmailView.vue';
// import AdminLogsView from '../views/AdminLogsView.vue';
// import NotFoundView from '../views/NotFoundView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    // component: HomeView, // Exemple de page d'accueil
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'), // Lazy loading
    meta: {
      requiresAuth: false,
      title: 'MOH.IMMO - Réservez votre logement meublé en Afrique',
      description: 'Plateforme de réservation de logements meublés en Afrique avec paiement sécurisé, disponibilité en temps réel et facture PDF.',
      keywords: 'logement meublé, réservation en ligne, Afrique, MOH.IMMO'
    }
  },
  {
    path: '/admin/reservations',
    name: 'reserve',
    // component: HomeView, // Exemple de page d'accueil
    component: () => import(/* webpackChunkName: "home" */ '../views/Reservation.vue'), // Lazy loading
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }// Accessible à tous
  },
  { path: '/admin/apartments', component: AdminApartmentList,
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }
   },
  { path: '/admin/sites', component: AdminSiteList,
    meta: { requiresAuth: true, roles: ['superAdmin'] }
   },
  { path: '/admin/employee', component: AdminEmployee,
    meta: { requiresAuth: true, roles: ['superAdmin'] }
   },
  { path: '/admin/apartments/add', component: AdminAddApartment,
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }
   },
  { path: '/admin/apartments/edit/:id', component: AdminEditApartment,
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }
   },
  { path: '/admin/review', component: AdminReview,
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }
   },

  // Client
  { path: '/apartments/:id', component: DetailsLogement,
    meta: { requiresAuth: false}
   },
  { path: '/apartments/:id/reserve', component: ClientMultiStepReservation },
  //{ path: '/admin', component: AdminDashboard },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: {
      requiresAuth: false,
      title: 'Contact - MOH.IMMO',
      description: 'Contactez MOH.IMMO pour vos questions ou demandes de réservation.',
      keywords: 'contact, MOH IMMO, assistance, réservation'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true, roles: ['superAdmin'] }
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: ReservationView,
    meta: {
      requiresAuth: false,
      title: 'Disponibilité - MOH.IMMO',
      description: 'Consultez la disponibilité des logements meublés et réservez en ligne rapidement.',
      keywords: 'disponibilité logement, réservation, MOH.IMMO'
    }
  },
  {
    path: '/logements',
    name: 'logements',
    component: LogementsView,
    meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      requiresAuth: false,
      title: 'À propos - MOH.IMMO',
      description: 'En savoir plus sur MOH.IMMO, votre solution de réservation de logements meublés modernes et sécurisés.',
      keywords: 'MOH IMMO, à propos, logement sécurisé, Afrique'
    }
  },
  {
    path: '/review/manual',
    name: 'ManualReview',
    component: () => import('@/views/ManualReview.vue')
  },
  {
    path: '/review/:reservationId',
    name: 'ReservationReview',
    component: () => import('@/views/ReservationReview.vue')
  },
  //{
  //  path: '/logements/:id',
  //  name: 'Details logement',
  //  component: DetailsLogement,
  //  meta: { requiresAuth: false }
  //},
  {
    path: '/login',
    name: 'login',
    // component: LoginView,
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: { requiresAuth: false, guestOnly: true } // Accessible seulement si non connecté
  },
  {
    path: '/register/djhdekuiz762872jsn/admin/6728989115171011018/exclusif',
    name: 'register',
    // component: RegisterView,
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue'),
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    // component: ForgotPasswordView,
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    // component: ResetPasswordView,
    component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPasswordView.vue'),
    props: true, // Passe le :token comme prop au composant
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/verify-email/:token',
    name: 'verify-email',
    // component: VerifyEmailView,
    component: () => import(/* webpackChunkName: "verify-email" */ '../views/VerifyEmailView.vue'),
    props: true,
    meta: { requiresAuth: false } // Peut être accédé même si connecté (ex: lien cliqué depuis email)
  },

  // --- Routes Protégées (Authentification requise) ---
  {
    path: '/profile',
    name: 'profile',
    // component: ProfileView,
    component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pubs',
    name: 'pubs',
    // component: ProfileView,
    component: () => import(/* webpackChunkName: "profile" */ '../views/admin/AdsView.vue'),
    meta: { requiresAuth: true }
  },

    // Dans votre router (router/index.js)
  {
    path: '/reservation/confirmation',
    name: 'ReservationConfirmation',
    component: () => import('../views/ReservationConfirmation.vue'),
    props: (route) => ({
      reservationId: route.query.reservationId,
      transactionId: route.query.transactionId, // ID de transaction KKiaPay
      status: route.query.status // Statut pré-calculé
    })
  },

  // --- Routes Protégées (Rôle spécifique requis) ---
  {
    path: '/admin/logs',
    name: 'admin-logs',
    // component: AdminLogsView,
    component: () => import(/* webpackChunkName: "admin-logs" */ '../views/AdminLogsView.vue'),
    meta: { requiresAuth: true, roles: ['superAdmin'] } // Accessible uniquement par superAdmin
  },
  // Ajoutez d'autres routes admin ici...
  // {
  //   path: '/admin/dashboard',
  //   name: 'admin-dashboard',
  //   component: () => import(/* webpackChunkName: "admin-dashboard" */ '../views/AdminDashboardView.vue'),
  //   meta: { requiresAuth: true, roles: ['admin', 'superAdmin'] } // Accessible par admin et superAdmin
  // },

  // --- Route de Déconnexion (Action) ---
  // Il est souvent préférable de gérer la déconnexion via une action dans un composant (ex: bouton dans le header)
  // plutôt qu'une route dédiée. L'action appellerait `authStore.logout()` puis redirigerait.

  // --- Route Not Found (404) ---
  //{
  //  path: '/:pathMatch(.*)*', // Capture toutes les routes non définies
  //  name: 'NotFound',
  //  // component: NotFoundView,
  //  component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFoundView.vue'),
  //  meta: { requiresAuth: false }
  //}
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Ou import.meta.env.BASE_URL avec Vite
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
});

// Garde de navigation globale
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Essayer de récupérer l'utilisateur si le store n'est pas initialisé
  // (utile si l'utilisateur recharge la page sur une route protégée)
  if (!authStore.isLoggedIn && !authStore.isLoading) {
      // Vérifier si un cookie existe potentiellement (on ne peut pas le lire directement)
      // On tente de fetch l'utilisateur basé sur le cookie httpOnly potentiel
      // Si fetchUser échoue, isLoggedIn restera false.
      await authStore.fetchUser();
  }

  const requiresAuth = to.meta.requiresAuth;
  const guestOnly = to.meta.guestOnly;
  const requiredRoles = to.meta.roles as string[] | undefined;

  // Mise à jour des meta tags
  const defaultTitle = 'MOH.IMMO - Réservez des logements meublés en Afrique';
  document.title = (to.meta.title as string) || defaultTitle;

  // Meta description
  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute('content', to.meta.description as string || '');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = to.meta.description as string || '';
    document.head.appendChild(meta);
  }

  // Meta keywords
  const keywords = document.querySelector('meta[name="keywords"]');
  if (keywords) {
    keywords.setAttribute('content', to.meta.keywords as string || '');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'keywords';
    meta.content = to.meta.keywords as string || '';
    document.head.appendChild(meta);
  }

  // 1. Si la route nécessite d'être authentifié et que l'utilisateur ne l'est pas
  if (requiresAuth && !authStore.isLoggedIn) {
    console.log('Navigation Guard: Not logged in, redirecting to login.');
    // Sauvegarder l'URL voulue pour rediriger après connexion (optionnel)
    // next({ name: 'login', query: { redirect: to.fullPath } });
    return next({ name: 'login' });
  }
  // 2. Si la route est réservée aux invités (non connectés) et que l'utilisateur est connecté
  else if (guestOnly && authStore.isLoggedIn) {
    console.log('Navigation Guard: Logged in, redirecting from guest-only route to home.');
    return next({ name: 'home' }); // Ou '/profile' ou une autre page par défaut pour les connectés
  }
  // 3. Si la route nécessite un rôle spécifique
  else if (requiresAuth && requiredRoles && requiredRoles.length > 0) {
    if (!authStore.userRole || !requiredRoles.includes(authStore.userRole)) {
      console.log(`Navigation Guard: Role mismatch. User role: ${authStore.userRole}, Required: ${requiredRoles}. Redirecting.`);
      // Rediriger vers une page non autorisée ou la page d'accueil
      // next({ name: 'unauthorized' });
      return next({ name: 'home' }); // Ou une page d'erreur spécifique
    }
  }
  
  // 4. Sinon (route publique, ou route protégée avec authentification/rôle OK)
  next();
});

export default router;
